<template>
  <dt-wrap>
    <cat-btn
      v-tooltip="'Open examples in new tab'"
      class="mob-link text-size-small"
      :href="'?mobile=true&' + link"
      target="_blank"
      link
      icon="clone"
    >
      {{ linkText }}</cat-btn
    >
  </dt-wrap>
</template>

<script>
import { defineComponent } from "vue";
import DtWrap from "./dt-wrap";

export default defineComponent({
  components: { DtWrap },
  name: "MobLink",
  props: {
    linkText: {
      required: false,
      default: "Examples in new tab",
      type: String
    },
    link: {
      required: true,
      type: String,
      default: undefined
    }
  }
});
</script>
